import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-additionalproducts",
  "use": "icon-soc-m-additionalproducts-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-additionalproducts\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"300\" cy=\"280\" r=\"28\" /><rect x=\"224\" y=\"256\" width=\"576\" height=\"512\" rx=\"32\" /><path d=\"M320 352h96v96H320zM448 352h96v96H448zM576 352h96v96H576z\" fill=\"#fff\" /><path d=\"M320 544h384v96H320z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-additionalproducts.svg
// module id = QWC5
// module chunks = 491